import { IconButton } from '@common-components';
import { Delete as DeleteIcon } from '@icons';
import { UserStatus } from 'enums';
import { useBoolean, useMutateUser } from 'hooks';
import { messages } from 'i18n';
import { User } from 'types';
import { ConfirmationDialog } from 'components/Dialog';

interface DeleteAgentButtonProps {
  agent: User;
}

export function DeleteAgentButton({ agent }: DeleteAgentButtonProps) {
  const { agenciesPage, buttons } = messages;

  const dialogMessages = agenciesPage.deleteAgent.dialog;

  const { updateUser } = useMutateUser();
  const [isDeleteAgentConfirmationOpen, { on: openDeleteAgentConfirmation, off: closeDeleteAgentConfirmation }] =
    useBoolean(false);

  const deleteAgent = async () => {
    await updateUser.mutateAsync({
      id: agent.id,
      data: { status: UserStatus.Disabled },
    });
  };

  return (
    <>
      <IconButton
        onClick={openDeleteAgentConfirmation}
        icon={DeleteIcon}
        size="small"
        variant="text"
        color="secondary"
      />
      <ConfirmationDialog
        title={dialogMessages.title}
        message={dialogMessages.body(agent.email)}
        isOpen={isDeleteAgentConfirmationOpen}
        onCancel={closeDeleteAgentConfirmation}
        onSubmit={deleteAgent}
        cancelButton={{ children: buttons.cancel, color: 'secondary' }}
        proceedButton={{
          loading: false,
          color: 'error',
          children: dialogMessages.button,
        }}
      />
    </>
  );
}
